// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__245ku","title":"Header_title__1CW4e","left":"Header_left__1yfuI","clinicName":"Header_clinicName__3ljvt"};